import { ChangeDetectionStrategy, Component, untracked } from '@angular/core';
import { GridCellRenderer } from '@softapps/core/grid';
import { Product } from './product';
import { IconComponent, modalFn } from '@softline/ui-core';
import { ArtikelInfoComponent } from '../../artikel/dialogs/artikel-info/artikel-info.component';

@Component({
  selector: 'soft-product-column',
  imports: [
    IconComponent
  ],
  template: `
    @if (value(); as value) {
      <div class="flex flex-row justify-between items-center w-full">
        <div class="flex flex-row gap-2">
            <div class="flex flex-col justify-center items-center bg-gray-300 rounded-lg mt-1 h-8 min-w-8 w-8">
              <soft-icon name="fa-regular fa-camera-slash"></soft-icon>
            </div>
          <div class="flex flex-col">
            <span class="soft-overline !mb-0">{{ value.cartikelnummer }}</span>
            <span class="text-sm">{{ value.artbez1 }}</span>
          </div>
        </div>
        <div class="">
          <soft-icon name="fa-regular fa-arrow-up-right-from-square"
                     class="pointer"
                     (click)="openProductInfoModal(value.id)"></soft-icon>
        </div>
      </div>
    }`,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductColumnComponent<TRow extends object> extends GridCellRenderer<TRow, Product>{
  private readonly modal = modalFn();

  openProductInfoModal(id: number) {
    return this.modal({
      component: ArtikelInfoComponent,
      dismiss: true,
      title: 'Artikelinformationen',
      data: {
        id: untracked(() => id),
        options: {
          data: {
            vkforgRestriction: false,
            showEslFlash: false,
          },
        },
      },
    });
  }
}
